import React, { useState } from 'react'
import { MenuAccordionItem } from 'components/molecules'
import PropTypes from 'prop-types'

const MenuAccordion = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const openIndex = (index) => {
    if (index === activeIndex) setActiveIndex(-1)
    else setActiveIndex(index)
  }

  return (
    <>
      {data.map((item, index) => (
        <MenuAccordionItem
          isFirst={index === 0}
          title={item.title}
          key={item.title}
          isOpen={index === activeIndex}
          onClick={() => openIndex(index)}
          isStretched={item.isStretched || false}
        >
          {item.children}
        </MenuAccordionItem>
      ))}
    </>
  )
}

MenuAccordion.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    children: PropTypes.node,
    isStretched: PropTypes.boolean,
  })),
}

MenuAccordion.defaultProps = {
  data: []
}


export default MenuAccordion
